// ==============================|| THEME CONFIG  ||============================== //

const config = {
  defaultPath: '/login',
  defaultHomePath: '/dashboard/default',
  fontFamily: `'Public Sans', sans-serif`,
  i18n: 'en',
  miniDrawer: false,
  container: true,
  mode: 'light',
  presetColor: 'default',
  themeDirection: 'ltr',
  sessionDuration: '3hr'
};

export const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
export const PUBLIC_PATHS = ['/', '/login', '/register', '/forgot-password', '/verification', '/initialize-registration'];
export const DEBOUNCE_DELAY = 100;
export const SESSION_REFRESH_BUFFER = 30000; // 30 seconds before expiration

export default config;
export const drawerWidth = 260;
export const recordsPerPage = 15;
export const recordsPerPageOptions = [5, 10, 15, 20, 25];

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';
